/* Bespoke Patio: friendly "crafting your piece" state on Add to cart.
   Custom options (APO) can take several seconds to price and add, so the button shows a spinner and rotating,
   on-brand messages instead of looking frozen. Never blocks or changes the add itself; it only reads the
   cart request to know when to finish. Remove the script tag in layout/theme.liquid to undo. */
(function () {
  if (window.__bpCrafting) return; window.__bpCrafting = true;
  var CUSTOM = ['Crafting your piece…', 'Matching fabric…', 'Pairing finish…', 'Adding details…', 'Almost ready…'];
  var OPTS = ['Adding options…', 'Preparing your order…', 'Almost ready…'];
  var PLAIN = ['Adding to your cart…'];
  var css = '.bp-crafting{position:relative;pointer-events:none;opacity:1 !important;color:transparent !important;-webkit-text-fill-color:transparent !important;font-size:0 !important}' + '.bp-crafting .bp-craft{-webkit-text-fill-color:currentColor !important}' +
    '.bp-crafting>*:not(.bp-craft){visibility:hidden}' +
    '.bp-craft{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;gap:8px;padding:0 10px;font-family:Inter,sans-serif !important;font-weight:600;font-size:14px;line-height:1.2;letter-spacing:.02em;text-transform:none;white-space:nowrap;overflow:hidden;visibility:visible}' + '.bp-craft span{overflow:hidden;text-overflow:ellipsis}' +
    '.bp-craft i{width:16px;height:16px;border-radius:50%;border:2px solid currentColor;border-right-color:transparent;animation:bpspin .8s linear infinite;flex:0 0 16px}' +
    '.bp-craft-note{display:block;margin-top:8px;font:400 12.5px/1.4 Inter,sans-serif;color:#6B655B;text-align:center}' +
    '@keyframes bpspin{to{transform:rotate(360deg)}}' +
    '.bp-cart-updating{position:fixed;inset:0;z-index:2147483646;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;background:rgba(251,248,243,.97);opacity:0;transition:opacity .25s ease}' +
    '.bp-cart-updating.is-on{opacity:1}' +
    '.bp-cart-updating i{width:30px;height:30px;border-radius:50%;border:2.5px solid #7C5F35;border-right-color:transparent;animation:bpspin .8s linear infinite}' +
    '.bp-cart-updating b{font:500 21px/1.3 Fraunces,serif;color:#2B251F}' +
    '.bp-cart-updating span{font:400 14px/1.4 Inter,sans-serif;color:#7A6F63}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var active = null, timer = null, failsafe = null, note = null, buyNow = false;
  var modal = null, modalObs = null, updating = null, cartTouched = false;
  // After an Edit Options Submit, APO reloads the cart. The brand-new priced item can take a few seconds to be fully
  // ready in Shopify (blank name, no picture, $0.00 for a moment), so the cream screen stays up across the reload
  // until /cart.js shows every customized item with its name and price. Limits: 3 extra reloads, 20 seconds.
  var KEY = 'bpCartUpdating';
  function remember(v) { try { v ? sessionStorage.setItem(KEY, JSON.stringify(v)) : sessionStorage.removeItem(KEY); } catch (e) {} }
  function recall() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function hideUpdating() { remember(null); if (!updating) return; var u = updating; updating = null; u.classList.remove('is-on'); setTimeout(function () { u.remove(); }, 260); }
  function showUpdating(state) {
    if (!updating) {
      updating = document.createElement('div'); updating.className = 'bp-cart-updating'; updating.setAttribute('role', 'status');
      updating.innerHTML = '<i aria-hidden="true"></i><b>Updating your cart…</b><span>Saving your new selections</span>';
      document.body.appendChild(updating);
      requestAnimationFrame(function () { updating && updating.classList.add('is-on'); });
    }
    remember(state || { t: Date.now(), n: 0 });
    setTimeout(hideUpdating, 20000);  // never trap anyone
  }
  function notReady(it) {  // an APO-customized line whose new product isn't fully registered yet
    var apo = /mws_apo/.test(it.url || it.handle || '') || Object.keys(it.properties || {}).some(function (k) { return /mws/i.test(k); });
    return apo && (!it.product_title || !it.final_price || it.final_price <= 0);
  }
  function settleCart() {
    var s = recall();
    if (!s || Date.now() - s.t > 20000 || !/\/cart\/?$/.test(location.pathname)) { remember(null); return; }
    showUpdating(s);
    var tries = 0;
    (function check() {
      fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        if ((c.items || []).some(notReady) && ++tries < 45) return setTimeout(check, 400);
        // the cart data is ready; if this page was drawn before it was (a $0.00 line), refresh once more behind the screen
        var stale = [].some.call(document.querySelectorAll('.cart-item, [data-cartitem]'), function (el) { return /\$0\.00/.test(el.textContent || ''); })
          && (c.items || []).every(function (it) { return it.final_price > 0; });
        if (stale && s.n < 3) { s.n += 1; remember(s); return location.reload(); }
        hideUpdating();
      }).catch(function () { hideUpdating(); });
    })();
  }
  function start(btn, isBuyNow) {
    if (active) return;
    buyNow = !!isBuyNow;
    // messages follow what this product actually has you choose (fabric only when there is a fabric, etc.)
    var scope = btn.closest('.mw-tingle') || document;  // in the cart pop-up, read only the pop-up's options
    var opts = [].filter.call(scope.querySelectorAll('.mw-option'), function (o) { return o.offsetParent !== null; });
    var custom = opts.length > 0, k = { fabric: 0, finish: 0, top: 0, other: 0 };
    opts.forEach(function (o) {
      var t = ((o.querySelector('.mw-text--style-strong') || {}).textContent || '').toLowerCase();
      if (/fabric|cushion|sling|welt|pillow|canopy/.test(t)) k.fabric = 1;
      else if (/finish|frame|color|colour/.test(t)) k.finish = 1;
      else if (/top|tile/.test(t)) k.top = 1;
      else k.other = 1;
    });
    var made = k.fabric || k.finish || k.top, msgs;
    if (!custom) msgs = PLAIN.slice();
    else {
      msgs = [made ? 'Crafting your piece…' : 'Adding your options…'];
      if (k.fabric) msgs.push('Matching fabric…');
      if (k.finish) msgs.push('Pairing finish…');
      if (k.top) msgs.push('Setting the top…');
      if (k.other) msgs.push(made ? 'Adding details…' : 'Preparing your order…');
      msgs.push('Almost ready…');
    }
    var picked = [k.finish && 'finish', k.fabric && 'fabric', k.top && 'top'].filter(Boolean);
    var noteText = picked.length ? 'We’re pricing your exact ' + (picked.length > 1 ? picked.slice(0, -1).join(', ') + ' and ' + picked[picked.length - 1] : picked[0]) + '. This takes a few seconds.'
                                 : 'We’re adding your selected options. This takes a few seconds.';
    var i = 0;
    if (buyNow) msgs[msgs.length - 1] = 'Heading to checkout…';
    var ink = getComputedStyle(btn).color;
    active = btn; btn.classList.add('bp-crafting'); btn.setAttribute('aria-busy', 'true');
    modal = btn.closest('.mw-tingle'); cartTouched = false;
    if (modal) {
      // APO only closes the pop-up when the update succeeded, then reloads the cart page. Watch for that close.
      modalObs = new MutationObserver(function () { if (!document.contains(modal)) { modalObs.disconnect(); if (cartTouched) showUpdating(); else stop(); } });
      modalObs.observe(document.body, { childList: true, subtree: true });
    }
    var box = document.createElement('span'); box.className = 'bp-craft'; box.setAttribute('aria-live', 'polite'); box.style.color = buyNow ? '#6E5234' : ink; if (btn.offsetWidth < 230) { box.style.fontSize = '12.5px'; box.style.letterSpacing = '0'; box.style.gap = '6px'; }
    box.innerHTML = '<i aria-hidden="true"></i><span>' + msgs[0] + '</span>';
    btn.appendChild(box);
    if (custom) {
      note = document.createElement('span'); note.className = 'bp-craft-note';
      note.textContent = noteText;
      btn.insertAdjacentElement('afterend', note);
    }
    timer = setInterval(function () { i = Math.min(i + 1, msgs.length - 1); box.lastChild.textContent = msgs[i]; }, 1400);
    failsafe = setTimeout(stop, 20000);
  }
  function stop() {
    if (!active) return;
    clearInterval(timer); clearTimeout(failsafe);
    var b = active.querySelector('.bp-craft'); if (b) b.remove();
    if (note) { note.remove(); note = null; }
    active.classList.remove('bp-crafting'); active.removeAttribute('aria-busy'); active = null;
    if (modalObs) { modalObs.disconnect(); modalObs = null; } modal = null;
  }
  function done() { cartTouched = true; if (active && !buyNow && !modal) setTimeout(stop, 400); }  // pop-up Submit: keep the spinner until APO closes it  // Buy now ends when the page moves to checkout

  document.addEventListener('click', function (e) {
    // Oct 6 2026: also the Submit button in APO's cart "Edit Options" pop-up (it re-prices the piece the same way)
    var btn = e.target.closest('form[action*="/cart/add"] [type="submit"], button[name="add"], .product-form--atc-button, .mw-apo-buy-it-now, .shopify-payment-button__button, .mw-tingle .tingle-modal-box__footer .btn--primary');
    if (!btn || btn.disabled) return;
    var isBuyNow = btn.matches('.mw-apo-buy-it-now, .shopify-payment-button__button');
    // let the options app validate first; only show the state if nothing is marked missing
    setTimeout(function () {
      var err = [].some.call(document.querySelectorAll('.mw-option [class*="error"], .mw-option [class*="invalid"], .mw-text--style-negative'), function (el) {
        return el.offsetParent !== null && /required|select|choose/i.test(el.textContent || '');
      });
      if (!err) start(btn, isBuyNow);
    }, 120);
  }, true);

  // finish when the cart request completes (fetch or XHR), whichever the theme or app uses
  var isCart = function (u) { return /\/cart\/(add|change|update)/.test(String(u || '')); };
  if (window.fetch) {
    var f = window.fetch;
    window.fetch = function (input, init) {
      var u = typeof input === 'string' ? input : (input && input.url);
      var pr = f.apply(this, arguments);
      if (isCart(u)) pr.then(done, done);
      return pr;
    };
  }
  var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
  // Oct 11 2026 fix for "Cannot find variant" on the first Add to cart (owner, reproduced on the Woodard Reed sofa):
  // for a priced choice APO creates a brand-new hidden variant, then posts /cart/add.js a moment later. Shopify sometimes
  // has not finished registering that variant and answers 422 "Cannot find variant"; a second click then works.
  // For each /cart/add request we post it ourselves and, only on that exact 422, wait and try again (every 0.8 s, up to
  // 7 tries, about 5 s). The original request then receives the final answer unchanged, so APO and the theme carry on as normal.
  // Any other result (success or a real error such as out of stock) is passed straight through. Undo: delete this block.
  var isAdd = function (u) { return /\/cart\/add/.test(String(u || '')); };
  var notYet = function (st, t) { return st === 422 && /find variant/i.test(t || ''); };
  XMLHttpRequest.prototype.open = function (m, u, as) {
    this.__bpCart = isCart(u); this.__bpAdd = isAdd(u) && String(m).toUpperCase() === 'POST' && as !== false; this.__bpArgs = arguments; this.__bpHdr = [];
    return open.apply(this, arguments);
  };
  var setHdr = XMLHttpRequest.prototype.setRequestHeader;
  XMLHttpRequest.prototype.setRequestHeader = function (k, v) { if (this.__bpHdr) this.__bpHdr.push([k, v]); return setHdr.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    var x = this, args = arguments;
    if (x.__bpCart) x.addEventListener('loadend', done);
    if (!x.__bpAdd || !f || typeof Blob === 'undefined') return send.apply(x, args);
    var hdr = {}; x.__bpHdr.forEach(function (h) { hdr[h[0]] = h[1]; });
    var tries = 0;
    function original() { try { open.apply(x, x.__bpArgs); x.__bpHdr.forEach(function (h) { setHdr.apply(x, h); }); } catch (e) {} send.apply(x, args); }
    function deliver(text) {  // hand the final answer to the waiting request without adding the item a second time
      try {
        var url = URL.createObjectURL(new Blob([text], { type: 'application/json' }));
        open.call(x, 'GET', url, true); send.call(x); setTimeout(function () { URL.revokeObjectURL(url); }, 30000);
      } catch (e) { original(); }
    }
    (function attempt() {
      f(String(x.__bpArgs[1]), { method: 'POST', body: body, headers: hdr, credentials: 'same-origin' }).then(function (r) {
        return r.text().then(function (t) {
          if (notYet(r.status, t) && ++tries < 7) return setTimeout(attempt, 800);
          if (r.ok) return deliver(t);
          original();  // a real error: let the original request show it as before
        });
      }).catch(original);
    })();
  };
  if (f) {
    var f2 = window.fetch;
    window.fetch = function (input, init) {
      var u = typeof input === 'string' ? input : (input && input.url), self = this, a = arguments, n = 0;
      if (!isAdd(u) || !init || String(init.method || '').toUpperCase() !== 'POST') return f2.apply(this, arguments);
      return new Promise(function (res, rej) {
        (function attempt() {
          f2.apply(self, a).then(function (r) {
            if (r.status !== 422 || n >= 6) return res(r);
            r.clone().text().then(function (t) { if (notYet(r.status, t)) { n++; setTimeout(attempt, 800); } else res(r); }, function () { res(r); });
          }, rej);
        })();
      });
    };
  }
  // a full page navigation (non-AJAX add) also ends it
  window.addEventListener('pagehide', stop);
  // Oct 11 2026 (owner, phone): going Back from the cart restores this page from the browser's memory with the spinner
  // still drawn. When the page is shown again from that memory, clear every spinner, note and busy state.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    stop();
    [].forEach.call(document.querySelectorAll('.bp-craft, .bp-craft-note'), function (el) { el.remove(); });
    [].forEach.call(document.querySelectorAll('.bp-crafting'), function (el) { el.classList.remove('bp-crafting'); el.removeAttribute('aria-busy'); });
    [].forEach.call(document.querySelectorAll('.bp-pdpm-bar button[disabled]'), function (el) { el.disabled = false; });
  });
  // Oct 6 2026: − / + buttons on the quantity box in APO's Edit Options pop-up (it only has a bare number field)
  var stepCss = '.bp-qty{display:inline-flex;align-items:center;border:1px solid #E3D9CB;border-radius:10px;background:#fff;overflow:hidden}' +
    '.bp-qty button{width:44px;height:46px;border:0;background:transparent;color:#7C5F35;font:500 20px/1 Inter,sans-serif;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
    '.bp-qty button:active{background:#F5F0E8}' +
    '.mw-tingle .bp-qty input[type="number"]{width:56px !important;height:46px !important;border:0 !important;border-radius:0 !important;box-shadow:none !important;text-align:center;padding:0 !important;-moz-appearance:textfield}' +
    '.bp-qty input::-webkit-outer-spin-button,.bp-qty input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}';
  var stepSt = document.createElement('style'); stepSt.textContent = stepCss; document.head.appendChild(stepSt);
  function addSteppers() {
    [].forEach.call(document.querySelectorAll('.mw-tingle input[type="number"]:not([data-bp-qty])'), function (inp) {
      inp.setAttribute('data-bp-qty', '1');
      var wrap = document.createElement('span'); wrap.className = 'bp-qty';
      inp.parentNode.insertBefore(wrap, inp);
      function btn(label, d) {
        var b = document.createElement('button'); b.type = 'button'; b.textContent = label; b.setAttribute('aria-label', d < 0 ? 'Decrease quantity' : 'Increase quantity');
        b.addEventListener('click', function () {
          var min = parseInt(inp.min, 10) || 1, max = parseInt(inp.max, 10) || 999;
          inp.value = Math.max(min, Math.min(max, (parseInt(inp.value, 10) || min) + d));
          inp.dispatchEvent(new Event('input', { bubbles: true })); inp.dispatchEvent(new Event('change', { bubbles: true }));
        });
        return b;
      }
      wrap.appendChild(btn('−', -1)); wrap.appendChild(inp); wrap.appendChild(btn('+', 1));
    });
  }
  new MutationObserver(function () { if (document.querySelector('.mw-tingle input[type="number"]:not([data-bp-qty])')) addSteppers(); })
    .observe(document.documentElement, { childList: true, subtree: true });

  // resume the cream screen after APO's reload (see settleCart)
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', settleCart); else settleCart();

  // Cart safety net (Oct 5 2026): removing an item that has an APO one-time add-on (e.g. a Bromic control) runs a chain
  // (theme remove -> reload -> APO removes the linked hidden line -> reload). If that chain stalls, the line stays greyed
  // out. If the page has not moved on 7 seconds after a remove or quantity change on the cart page, reload it.
  if (/\/cart\/?$/.test(location.pathname)) {
    var bpCartTimer = null;
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.cart-item__remove-link, .cart-item__remove, [name="updates[]"], .quantity-selector__button, [data-quantity-minus], [data-quantity-plus]')) return;
      clearTimeout(bpCartTimer);
      bpCartTimer = setTimeout(function () { location.reload(); }, 7000);
    }, true);
    window.addEventListener('pagehide', function () { clearTimeout(bpCartTimer); });
  }
})();
